import React, {useRef} from 'react';
import {BuyerNote} from '../../Components/BuyerNote/BuyerNote';
import {CartItems} from '../../Components/CartItems/CartItems';
import {Coupon} from '../../Components/Coupon/Coupon';
import {Headline} from '../../Components/Headline/Headline';
import {OrderSummary} from '../../Components/OrderSummary/OrderSummary';
import {useControllerProps} from '../../ControllerContext';
import s from './CartBody.scss';
import {CheckoutButtons} from '../../Components/CheckoutButtons/CheckoutButtons';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {CartScreenReaderMessage} from './CartScreenReaderMessage/CartScreenReaderMessage';
import {MinimumOrderAmount} from '../../Components/MinimumOrderAmount/MinimumOrderAmount';
import {SecureCheckout} from '../../Components/SecureCheckout/SecureCheckout';
import {Violations} from '../../Components/Violations/Violations';
import {SPECS} from '../../../../../domain/specs';

export const CartBody = () => {
  const {
    shouldShowCoupon,
    shouldShowBuyerNote,
    shouldShowMinimumOrderAmount,
    shouldShowTopCheckoutButtonInMobile,
    shouldShowSecureCheckout,
    shouldDisplayViolations,
  } = useControllerProps().cartStore;
  const {isMobile} = useEnvironment();
  const {experiments} = useExperiments();
  const cartBodyRef = useRef<HTMLDivElement>(null);
  let mainClassName = s.main;
  let summaryClassName = s.summary;

  /* istanbul ignore next */
  if (experiments.enabled(SPECS.UseClientWidthToResizeCartWidget) && cartBodyRef.current?.clientWidth <= 920) {
    mainClassName = s.mainOneColumn;
    summaryClassName = s.summaryOneColumn;
  }

  return (
    <main className={mainClassName} ref={cartBodyRef}>
      <section className={s.cart}>
        {isMobile && shouldShowTopCheckoutButtonInMobile && <CheckoutButtons isOnTop />}
        <Headline />
        <CartItems />
        <footer className={s.footer}>
          {shouldShowCoupon && (
            <div className={s.coupon}>
              <Coupon />
            </div>
          )}
          {shouldShowBuyerNote && (
            <div className={s.buyerNote}>
              <BuyerNote />
            </div>
          )}
        </footer>
        <CartScreenReaderMessage />
      </section>
      <aside className={summaryClassName}>
        <OrderSummary />
        {shouldDisplayViolations && <Violations />}
        {shouldShowMinimumOrderAmount && <MinimumOrderAmount />}
        <CheckoutButtons />
        {shouldShowSecureCheckout && <SecureCheckout />}
      </aside>
    </main>
  );
};
